/*
 * Created on Wed Oct 11 2023 4:54:25 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import { getUserRoleByDomain } from "../domain/Domain";
class User {
    constructor(userId, firstName, lastName, email, phoneNumber, profilePictureUrl, socialProfileUrl,
        address, dob, listOfEducationDetails, listOfEmploymentDetails, countryCode, status, description,
        resumeUrl, whyWorkWithUs, history, documents, company, password) {
        this.userId = userId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.phoneNumber = phoneNumber;
        this.profilePictureUrl = profilePictureUrl;
        this.socialProfileUrl = socialProfileUrl;
        this.address = address;
        this.dob = dob;
        this.listOfEducationDetails = listOfEducationDetails;
        this.listOfEmploymentDetails = listOfEmploymentDetails;
        this.countryCode = countryCode;
        this.status = status;
        this.description = description;
        this.resumeUrl = resumeUrl;
        this.whyWorkWithUs = whyWorkWithUs;
        this.history = history;
        this.documents = documents;
        this.company = company;

        // Check the domain type and set userRole accordingly
        const domainType = localStorage.getItem("domainType");
        this.userRole = getUserRoleByDomain(domainType);
    }
}

export default User;